import { POStatusTypes } from "@/api_framework/api_modals/Inventory";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { startCase } from "lodash";
import { useState } from "react";

export interface IPORaiseErrorModalStateProps {
  PONumber: string;
  POStatus: POStatusTypes;
  onSubmit: (issue: string) => void;
}

const PORaiseErrorModal: React.FC<IPORaiseErrorModalStateProps> = ({ PONumber, POStatus, onSubmit }) => {
  const [issue, setIssue] = useState<string>("");

  const handleSubmit = () => {
    onSubmit(issue);
  };

  return (
    <ModalPrompt
      modalId="PO_RAISE_ERROR_MODAL"
      title={`Raise An Issue ${PONumber ?? ""}`}
      button={{
        primaryButtonText: "Raise Issue",
        primaryButtonClassname: "bg-red-600 text-white",
        secondaryButtonText: "Cancel",
        primaryCallback: handleSubmit,
        shouldHideOnClick: true,
      }}
      content={
        <div className="text-gray-600 text-xs">
          <p>
            Raise an issue against this PO <span className="font-semibold">#{PONumber}</span> at{" "}
            <span className="font-semibold text-blue-600">{startCase(POStatus?.split("_")?.join(" "))}</span> state.
          </p>
          <div className="mt-4 w-full">
            <textarea
              placeholder="Enter reason..."
              className="rounded-md w-full"
              value={issue}
              onChange={(e) => setIssue(e.target.value)}
            />
          </div>
        </div>
      }
    />
  );
};

export default PORaiseErrorModal;
